<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">Aguacero</p>
<p class="fm1">beautiful musician</p>
<p class="fm1">unclothed at the foot of a tree</p>
<p class="fm1">amidst the lost harmonies</p>
<p class="fm1">close to our defeated memories</p>
<p class="fm1">amidst our hands of defeat</p>
<p class="fm1">and a people of alien strength</p>
<p class="fm1">we let our eyes hang low</p>
<p class="fm1">and untying</p>
<p class="fm1">the tether of a natal anguish</p>
<p class="fm1">we sobbed</p>
<p class="fm2">—Aimé Cesairé, “Blues of the Rain”</p>
<p class="fm3">trans. Clayton Eshleman and Annette Smith</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0005.vue?3312d562